
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9bTQb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6a431bc90b617b06$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $6a431bc90b617b06$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': 'Akce',
    'ai-smart-button.ai-actions.give-feedback-action.title': "Odeslat zp\u011Btnou vazbu",
    'ai-smart-button.ai-actions.help.section.text': "N\xe1pov\u011Bda",
    'ai-smart-button.ai-actions.input.link-picker-button-label': "P\u0159ipojit",
    'ai-smart-button.ai-actions.input.mention-button-label': "Zm\xednka",
    'ai-smart-button.ai-actions.input.send-button-label': 'Odeslat',
    'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
    'ai-smart-button.ai-actions.item.newLozenge': "NOV\xc9",
    'ai-smart-button.ai-actions.rovo-agents.add-icon-label': "P\u0159idat ikonu",
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': 'Ikona automatizace',
    'ai-smart-button.ai-actions.rovo-agents.automations.text': 'Automatizace',
    'ai-smart-button.ai-actions.rovo-agents.create-agent.text': "Proch\xe1zet agenty",
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': "Vytvo\u0159it automatizaci",
    'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': "Dobr\xfd den, {name},",
    'ai-smart-button.ai-proactive-nudge.dismiss': "Zav\u0159\xedt",
    'ai-smart-button.feedback-action.ask-question-option': "Polo\u017Eit ot\xe1zku",
    'ai-smart-button.feedback-action.cancel-button-label': "Zru\u0161it",
    'ai-smart-button.feedback-action.choose-feedback-option': "Vyberte jednu mo\u017Enost.",
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': "Popsat chybu nebo probl\xe9m",
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': "Dejte n\xe1m v\u011Bd\u011Bt, co si mysl\xedte",
    'ai-smart-button.feedback-action.feedback-entry-question-heading': "Co byste cht\u011Bli v\u011Bd\u011Bt?",
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "Dejte n\xe1m v\u011Bd\u011Bt, co byste cht\u011Bli zlep\u0161it",
    'ai-smart-button.feedback-action.feedback-modal-heading': "Sd\u011Blte n\xe1m sv\u016Fj n\xe1zor",
    'ai-smart-button.feedback-action.leave-comment-option': "Zanechat koment\xe1\u0159",
    'ai-smart-button.feedback-action.report-bug-option': "Ohl\xe1sit chybu",
    'ai-smart-button.feedback-action.research-participation-message': "Chci se z\xfa\u010Dastnit produktov\xe9ho pr\u016Fzkumu",
    'ai-smart-button.feedback-action.select-feedback-heading': "Vybrat zp\u011Btnou vazbu",
    'ai-smart-button.feedback-action.submit-button-label': "Odeslat zp\u011Btnou vazbu",
    'ai-smart-button.feedback-action.suggest-improvement-option': "Navrhnout zlep\u0161en\xed",
    'ai-smart-button.feedback-action.title': "Odeslat zp\u011Btnou vazbu",
    'ai-smart-button.feedback-item.icon-label': "Ikona zp\u011Btn\xe9 vazby",
    'ai-smart-button.reference.close-button-label': "Zav\u0159\xedt"
};

});


//# sourceMappingURL=cs.aa1323eb.js.map
